import { ProductScreenshot } from 'components/ProductScreenshot';
import cohortsPageLight from "../../../../contents/images/features/cohorts/cohorts-page-light-mode.png";
import cohortsPageDark from "../../../../contents/images/features/cohorts/cohorts-page-dark-mode.png";
import { ProductVideo } from 'components/ProductVideo';
import createCohortLight from "../../../../contents/images/features/cohorts/create-cohort-from-trend-light-mode.mp4";
import createCohortDark from "../../../../contents/images/features/cohorts/create-cohort-from-trend-dark-mode.mp4";
import * as React from 'react';
export default {
  ProductScreenshot,
  cohortsPageLight,
  cohortsPageDark,
  ProductVideo,
  createCohortLight,
  createCohortDark,
  React
};